<template>
  <div class="travel-category-page">
    <div class="page-header">
      <h2>旅游服务分类管理</h2>
      <el-button type="primary" icon="el-icon-plus" @click="handleAdd()">新增一级分类</el-button>
    </div>

    <el-card class="box-card">
      <el-table
        :data="tableData"
        style="width: 100%; margin-bottom: 20px;"
        row-key="id"
        border
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        v-loading="loading"
      >
        <el-table-column prop="code_name" label="分类名称" width="200"></el-table-column>
        <el-table-column prop="code" label="分类编码" width="150"></el-table-column>
        <el-table-column prop="level" label="层级" width="80" align="center"></el-table-column>
        <el-table-column prop="sort" label="排序" width="80" align="center"></el-table-column>
        <el-table-column label="默认选中" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.is_checked === 1 ? 'success' : 'info'">
              {{ scope.row.is_checked === 1 ? '是' : '否' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-edit"
              @click="handleEdit(scope.row)">编辑</el-button>
            <el-button
              size="mini"
              type="success"
              icon="el-icon-plus"
              @click="handleAdd(scope.row)">新增子分类</el-button>
            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 编辑/新增对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="上级分类" v-if="form.parent_code">
          <el-input v-model="parentName" disabled></el-input>
        </el-form-item>
        <el-form-item label="分类编码" prop="code">
          <el-input v-model="form.code" placeholder="请输入唯一编码"></el-input>
        </el-form-item>
        <el-form-item label="分类名称" prop="code_name">
          <el-input v-model="form.code_name" placeholder="请输入分类名称"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="form.sort" :min="0" :max="9999"></el-input-number>
        </el-form-item>
        <el-form-item label="默认选中" prop="is_checked">
           <el-switch
            v-model="form.is_checked"
            :active-value="1"
            :inactive-value="0"
            active-text="是"
            inactive-text="否">
          </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api';

export default {
  name: 'TravelCategory',
  data() {
    return {
      loading: false,
      tableData: [],
      rawList: [],
      dialogVisible: false,
      dialogTitle: '新增分类',
      parentName: '',
      form: {
        id: undefined,
        code: '',
        code_name: '',
        parent_code: '',
        level: 1,
        sort: 0,
        is_checked: 0
      },
      rules: {
        code: [{ required: true, message: '请输入分类编码', trigger: 'blur' }],
        code_name: [{ required: true, message: '请输入分类名称', trigger: 'blur' }]
      }
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const res = await api.travelCategory.getList();
        if (res.code === 1) {
          this.tableData = res.data.list;
          this.rawList = res.data.raw_list || [];
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      this.form = {
        id: undefined,
        code: '',
        code_name: '',
        parent_code: '',
        level: 1,
        sort: 0,
        is_checked: 0
      };
      this.parentName = '';
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },
    handleAdd(parentRow) {
      this.resetForm();
      this.dialogTitle = '新增分类';
      if (parentRow) {
        this.form.parent_code = parentRow.code;
        this.form.level = parentRow.level + 1;
        this.parentName = parentRow.code_name;
      } else {
        this.form.parent_code = '';
        this.form.level = 1;
      }
      this.dialogVisible = true;
    },
    handleEdit(row) {
      this.resetForm();
      this.dialogTitle = '编辑分类';
      // Clone row to avoid direct mutation
      this.form = { ...row };
      // Need to find parent name if parent_code exists
      if (this.form.parent_code) {
        const parent = this.rawList.find(item => item.code === this.form.parent_code);
        this.parentName = parent ? parent.code_name : this.form.parent_code;
      }
      this.dialogVisible = true;
    },
    handleDelete(row) {
      if (row.children && row.children.length > 0) {
        this.$message.warning('请先删除子分类');
        return;
      }
      this.$confirm('确认删除该分类?', '提示', {
        type: 'warning'
      }).then(async () => {
        try {
          const res = await api.travelCategory.del({ id: row.id });
          if (res.code === 1) {
            this.$message.success('删除成功');
            this.fetchData();
          }
        } catch (error) {
          console.error(error);
        }
      }).catch(() => {});
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            let res;
            if (this.form.id) {
              res = await api.travelCategory.edit(this.form);
            } else {
              res = await api.travelCategory.add(this.form);
            }
            if (res.code === 1) {
              this.$message.success(this.form.id ? '修改成功' : '添加成功');
              this.dialogVisible = false;
              this.fetchData();
            }
          } catch (error) {
            console.error(error);
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.travel-category-page {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.page-header h2 {
  margin: 0;
  color: #303133;
}
.box-card {
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
}
</style>
